import { createMutation } from '@tanstack/svelte-query';
import { createRCUChannel, deleteRCUChannel, patchRCUChannel } from '$lib/api/rcu_channel';
import {
  invalidateAfterChannelCreate,
  invalidateAfterChannelDelete,
  invalidateAfterChannelPatch
} from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { RCUChannelResponse } from '$lib/types/rcu_channel';
import type { RCUChannelPatch } from '$lib/types/rcu_channel';

export const createRCUChannelMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<
    RCUChannelResponse,
    Error,
    { rcu: number; channel_number: number; load?: number | null }
  >(() => ({
    mutationFn: (request) => createRCUChannel(request),
    onSuccess: () => invalidateAfterChannelCreate(resolveScope(scope))
  }));

export const deleteRCUChannelMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<void, Error, number>(() => ({
    mutationFn: (id) => deleteRCUChannel(id),
    onSuccess: () => invalidateAfterChannelDelete(resolveScope(scope))
  }));

export const patchRCUChannelMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<unknown, Error, { id: number; patch: RCUChannelPatch }>(() => ({
    mutationFn: ({ id, patch }) => patchRCUChannel(id, patch),
    onSuccess: () => invalidateAfterChannelPatch(resolveScope(scope))
  }));
